import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';

import { EnvServiceProvider } from '../../../environments/env.service.provider';
import { RecaptchaModule } from 'ng-recaptcha';

@NgModule({
  declarations: [ ],
  imports: [
    BrowserModule,
    RouterModule,
    ReactiveFormsModule,
    RecaptchaModule.forRoot(),
    ChartsModule
  ],
  exports: [ ],
  providers: [EnvServiceProvider]
})

export class AppviewsModule {
}
